import { action, makeAutoObservable } from 'mobx';
import { makePersistable } from 'mobx-persist-store';

import { persistConfig } from 'store/config';
import { type JsonDataItem } from 'types';

class ScriptStore {
  script: JsonDataItem = {};

  constructor() {
    makeAutoObservable(this);
    void makePersistable(this, {
      name: 'script-store',
      properties: ['script'],
      ...persistConfig,
    });
  }

  @action
  setScript = (script: JsonDataItem) => {
    this.script = script;
  };
}

export default new ScriptStore();
